import {
  CORE_HOTELS_NAME,
  CORE_UI_NAME,
  CoreHotelsComponent,
  CoreUiComponents,
} from "@b2bportal/core-types";
import { default as checkboxStyles } from "./styles/Checkbox.module.scss";
import { default as checkboxGroupStyles } from "./styles/CheckboxGroup.module.scss";
import { default as currencySelectorStyles } from "./styles/CurrencySelector.module.scss";
import { default as datePickerHorizontalViewStyles } from "./styles/DatePickerHorizontalView.module.scss";
import { default as dialogStyles } from "./styles/Dialog.module.scss";
import { default as filterDialogContainerStyles } from "./styles/FilterDialogContainer.module.scss";
import { default as filterRatingHorizontalStyles } from "./styles/FilterRatingHorizontal.module.scss";
import { default as hotelRoomRateStyles } from "./styles/HotelRoomRate.module.scss";
import { default as iframeDialogStyles } from "./styles/IframeDialog.module.scss";
import { default as languageSelectorStyles } from "./styles/LanguageSelector.module.scss";
import { default as switchStyles } from "./styles/Switch.module.scss";

export const styleOverrides = {
  [CORE_UI_NAME]: {
    [CoreUiComponents.LanguageSelector]: languageSelectorStyles,
    [CoreUiComponents.CurrencySelector]: currencySelectorStyles,
    [CoreUiComponents.IframeDialog]: iframeDialogStyles,
    [CoreUiComponents.Dialog]: dialogStyles,
    [CoreUiComponents.Checkbox]: checkboxStyles,
    [CoreUiComponents.DatePickerHorizontalView]: datePickerHorizontalViewStyles,
    [CoreUiComponents.FilterDialogContainer]: filterDialogContainerStyles,
    [CoreUiComponents.Switch]: switchStyles,
    [CoreUiComponents.CheckboxGroup]: checkboxGroupStyles,
  },
  [CORE_HOTELS_NAME]: {
    [CoreHotelsComponent.FilterRatingHorizontal]: filterRatingHorizontalStyles,
    [CoreHotelsComponent.HotelRoomRate]: hotelRoomRateStyles,
  },
};
